// extracted by mini-css-extract-plugin
module.exports = {"divCard":"deploy-efficiency_divCard_1KQBc","title":"deploy-efficiency_title_2_n0f","icon":"deploy-efficiency_icon_Uwafw"};